import { Injectable } from '@angular/core';
import { LocalStorageConstants } from '../constants/local-storage';
import { SecureLocalStorageService } from './secure-local-storage.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  userAuthorities = [] as any;
  constructor(private storageService: StorageService) {
  }

  setUserAuthorities() {
    try {
      const data = this.storageService.getData(LocalStorageConstants.userAuthorities);
      this.userAuthorities = data ? JSON.parse(data) : [];
    } catch (e) {
      this.userAuthorities = [];
    }
  }

  hasPermission(claimType: any): boolean {
    let ret = false;
    if (!this.userAuthorities || this.userAuthorities.length == 0) {
      return ret;
    }
    // See if an array of values was passed in.
    if (typeof claimType === 'string') {
      ret = this.isPermissionValid(claimType);
    } else {
      const permissions: string[] = claimType;
      if (permissions) {
        // tslint:disable-next-line: prefer-for-of
        for (let index = 0; index < permissions.length; index++) {
          ret = this.isPermissionValid(permissions[index]);
          // If one is successful, then let them in
          if (ret) {
            break;
          }
        }
      }
    }
    return ret;
  }

  private isPermissionValid(claimType: string): boolean {
    let ret = false;
    // Attempt to find the claim
    ret =
      this.userAuthorities.find(
        (c) =>
          c == claimType
      ) != null;
    return ret;
  }

  clearUserAuthorities() {
    this.userAuthorities = [];
  }
}
